import { Injectable } from '@angular/core';
import { CustomBaseStore } from '@city/const';
import { select, Store } from '@ngrx/store';
import { SiteContext, SiteContextConfig, StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { CityActions } from '../store/actions';
import { StateWithCity } from '../store/city-state';
import { CitySelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class BaseStoreFacade implements SiteContext<CustomBaseStore> {
  // алиасы для совместимости с интерфейсом SiteContext, лучше не использовать в силу небольшой информативности
  getActive = this.getActiveCode;
  getAll = this.getBaseStores;
  setActive = this.setActiveCode;

  constructor(
    protected store: Store<StateWithCity>,
    protected config: SiteContextConfig,
  ) {}

  getBaseStores(): Observable<CustomBaseStore[]> {
    return this.store.pipe(
      select(CitySelectors.getBaseStoresState),
      tap((state: StateUtils.LoaderState<CustomBaseStore[]>) => {
        if (!state.value && !state.loading && !state.error && !state.success) {
          this.store.dispatch(new CityActions.LoadBaseStores());
        }
      }),
      map(({ value }) => value),
      filter((baseStores: CustomBaseStore[]) => Boolean(baseStores)),
    );
  }

  getBaseStoresCodes(): Observable<string[]> {
    return this.getBaseStores().pipe(
      map((customBaseStores) => {
        return customBaseStores.map((store) => store.code);
      }),
    );
  }

  getActiveCode(): Observable<string> {
    return this.store.pipe(
      select(CitySelectors.getActiveBaseStore),
      filter((active: string) => Boolean(active)),
    );
  }

  delayedSetActiveCode(baseStoreCode: string): void {
    this.store.dispatch(new CityActions.DelayedSetActiveBaseStore(baseStoreCode));
  }

  getTemporaryBaseStoreCode(): Observable<string> {
    return this.store.pipe(select(CitySelectors.getTemporaryBaseStore));
  }

  // На сэт стора у нас очень много логики завязано.
  // Поэтому на уровне фасада я решил не этить тот же стор.
  // настройка форс нужна на всякий, чтобы это пробивать.
  setActiveCode(baseStoreCode: string, force: boolean = false): void {
    if (force) {
      this.store.dispatch(new CityActions.SetActiveBaseStore(baseStoreCode));
    } else {
      this.store
        .pipe(
          select(CitySelectors.getActiveBaseStore),
          take(1),
          filter((active: string) => active !== baseStoreCode),
        )
        .subscribe(() => this.store.dispatch(new CityActions.SetActiveBaseStore(baseStoreCode)));
    }
  }

  getActiveBaseStore(): Observable<CustomBaseStore | undefined> {
    return this.getActiveCode().pipe(switchMap((activeSiteUid: string) => this.getBaseStoreByCode(activeSiteUid)));
  }

  getBaseStoreByCode(code: string): Observable<CustomBaseStore | undefined> {
    return this.getBaseStores().pipe(
      map((baseStores: CustomBaseStore[]) => baseStores.find((baseStore: CustomBaseStore) => baseStore.code === code)),
    );
  }
}
